var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-callout-dismisser',{attrs:{"feature-name":"security_training_feature_promotion"},scopedSlots:_vm._u([{key:"default",fn:function({ dismiss, shouldShowCallout }){return [(shouldShowCallout)?_vm._t("default",null,null,{
        dismiss,
        buttonLink: _vm.buttonLink,
        buttonText: _vm.$options.i18n.buttonText,
        trackCTAClick: _vm.trackCTAClick,
      }):_vm._e()]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }